<template>
    <div v-if="date" class="booking-hourly-ranges">
        <h3 class="title" v-text="date.format('dddd DD MMMM')"></h3>
        <div class="columns">
            <div class="column is-half">
                <p class="subtitle" v-text="lang('Fascie mattutine')"></p>
                <ul v-if="! loading && ! error" class="ranges">
                    <li v-for="(range, index) in am" :key="range.name"
                        :class="{'is-danger': ! range.available,'selected': range.selected}"
                        @click.prevent="select(range)">
                        <span class="range" v-text="range.name"></span> <span class="indicator"></span>
                    </li>
                </ul>
            </div>
            <div class="column is-half">
                <p class="subtitle">Fascie pomeridiane</p>
                <ul v-if="! loading && ! error" class="ranges">
                    <li v-for="(range, index) in pm" :key="range.name"
                        :class="{ 'is-danger': ! range.available, 'selected': range.selected }"
                        @click.prevent="select(range)">
                        <span class="range" v-text="range.name"></span> <span class="indicator"></span>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="loading" class="calendar-loader has-text-centered"><i class="fas fa-spin fa-circle-notch fa-3x"></i></div>
        <div v-if="error" class="has-text-centered has-text-danger">
            <strong class="has-text-danger" v-text="error.error">Error</strong> <span v-text="error.errorDetails.error.message">Error message</span>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    import axios from 'axios'

    export default {
        props: {
            date: {
                required: true,
                type: Object
            },
            employee: {
                required: true,
                type: Object
            },
            reload: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                error: false,
                loading: false,
                ranges: []
            }
        },
        mounted() {
            // todo check for locale
            moment.locale('IT_it');
            this.fetchHours();
        },
        methods: {
            select( range ) {
                if( ! range.available ) return
                let index = this.ranges.indexOf( range )
                this.ranges.map( key => key.selected = false )
                this.ranges[index].selected = true
                this.$emit('selected', range)
            },
            fetchHours() {
                this.loading = true;
                axios.get('/calendar/api/'+this.employee.id+'/hours/'+this.date.date()+'/'+(this.date.month() + 1))
                    .then( response => {
                        this.ranges = response.data
                        this.loading = false;
                        this.$emit('fetched')
                    } )
                    .catch( error => {
                        this.error = error.response.data.response.original
                        this.loading = false
                        this.$emit('fetched')
                    })
            }
        },
        computed: {
            am() {
                return this.ranges.slice(0, 4)
            },
            pm() {
                return this.ranges.slice(4, 8)
            }
        },
        watch: {
            date() {
                this.fetchHours()
            },
            reload() {
                this.fetchHours()
            }
        }
    }
</script>